import {useEffect} from 'react';
import {useMatches} from "react-router-dom";
import {ScreenTracker} from "../utils/ScreenTracker";

// Tracking de navegación de pantallas (proyecto Reemplazo de Intercom, Fase 1.5A).
// En cada cambio de ruta toma handle.screen del ÚLTIMO match (el más específico) y, si existe,
// registra la vista en el buffer del ScreenTracker. Rutas sin handle.screen (redirects, públicas,
// auth) no se trackean. Componente funcional que no renderiza nada.
export const RouteTracker = () => {
    const matches = useMatches();

    useEffect(() => {
        if (!matches || matches.length === 0) {
            return;
        }
        const lastMatch = matches[matches.length - 1];
        const screen = lastMatch && lastMatch.handle && lastMatch.handle.screen;
        if (screen) {
            ScreenTracker.recordView(screen);
        }
    }, [matches]);

    return null;
};
